import { AxiosInstance } from 'axios';
import { simulate } from './utils';
import { type FormFields } from '../components/feedback/feedback.schema';

export const baseEndpoint = 'feedback';

export type ReferralIssueFields = {
  content: string;
  referralId: string;
  referralRevisionId?: string;
  name?: string;
  email?: string;
};

export class FeedbackApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async createFeedback(formValues: FormFields): Promise<void> {
    await simulate();
    const response = await this.apiInstance.post(`/`, formValues);

    return response.data;
  }

  async createReferralIssueReport(formValues: ReferralIssueFields): Promise<void> {
    await simulate();
    const response = await this.apiInstance.post('/referral-issue', formValues);

    return response.data;
  }
}
